import React, { useMemo } from 'react';
import CartSummary from '../CartSummary';
import GiftCard from '../GiftCard';
import PromoCode from '../PromoCode';
import { customerEmailSelector, customerIsLoggedInSelector } from 'store/customer/selectors';
import { useSelector } from 'react-redux';
import { Show } from 'components/Functional';
import ApplyStoreCredit from 'components/ApplyStoreCredit';
import Block from 'components/CMS/Block';
import { cartItemsSelector } from 'store/cart/selectors';
import QuoteDataCartItem from 'mage-swagfaces/quote/QuoteDataCartItem';
import { useProductSelectors } from 'hooks/useProductSelectors';
import { CTAWrapper, CartSideBarWrapper } from './styled';
import { TrackingProp } from 'react-tracking';

export interface CartSideBarProps {
  ctaButton: any;
  cartId: number;
  tracking: TrackingProp;
  isFinalStep?: boolean;
  isFirstStep?: boolean;
}

export interface AutoApplyStrikethroughValues {
  promoCode: string;
  itemPrice: number;
}

export const CartSideBar: React.FC<CartSideBarProps> = ({
  ctaButton,
  cartId,
  tracking,
  isFinalStep = false,
  isFirstStep = false
}) => {
  const { getStrikethroughValues } = useProductSelectors();
  const customerEmail = useSelector(customerEmailSelector);
  const cartItems = useSelector(cartItemsSelector);
  const isLoggedIn = useSelector(customerIsLoggedInSelector);

  const autoApplyStrikethroughValue = useMemo(() => {
    const autoApplyStrikethroughValues: AutoApplyStrikethroughValues[] = cartItems.map((item: QuoteDataCartItem) => ({
      promoCode: getStrikethroughValues(item.sku)?.promoCode,
      itemPrice: item.price
    }));

    const filteredAutoApplyStrikethroughValues: AutoApplyStrikethroughValues[] = autoApplyStrikethroughValues.filter(
      (autoApplyStrikethroughValues: AutoApplyStrikethroughValues) => autoApplyStrikethroughValues.promoCode
    );

    const sortedFilteredAutoApplyStrikethroughValues: AutoApplyStrikethroughValues[] = filteredAutoApplyStrikethroughValues.sort(
      (a: AutoApplyStrikethroughValues, b: AutoApplyStrikethroughValues) => (a.itemPrice > b.itemPrice ? -1 : 1)
    );

    return sortedFilteredAutoApplyStrikethroughValues.length
      ? sortedFilteredAutoApplyStrikethroughValues[0]?.promoCode
      : null;
  }, [cartItems, getStrikethroughValues]);

  return (
    <CartSideBarWrapper>
      <CartSummary
        isFirstStep={isFirstStep}
        isFinalStep={isFinalStep}
        tracking={tracking}
        cartId={cartId}
        email={customerEmail}
      />
      <Block
        id="cart_summary"
        render={content => <CartSideBarWrapper dangerouslySetInnerHTML={{ __html: content }} />}
      />{' '}
      <CTAWrapper>{ctaButton}</CTAWrapper>
      <>
        <Block
          id="promo_code_cart"
          render={content => <CartSideBarWrapper dangerouslySetInnerHTML={{ __html: content }} />}
        />{' '}
        <PromoCode autoApplyStrikethroughValue={autoApplyStrikethroughValue} />
        <Show when={isLoggedIn}>
          <GiftCard />
        </Show>
        <ApplyStoreCredit />
      </>
    </CartSideBarWrapper>
  );
};

export default CartSideBar;
